import { defineComponent } from "vue";

/**
 * 渲染 `Gateway` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Gateway = defineComponent({
	name: "Gateway",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M872 68.3H148.85c-45 0-81.9 36.9-81.9 82.35v723.15c0 45.45 36.9 81.9 81.9 81.9H872c45.45 0 81.9-36.9 81.9-81.9V150.65c0-45.45-36.9-82.35-81.9-82.35z m0 831.15H169.1l102.6-102.6c27 18.9 58.95 28.35 90.9 28.35 40.95 0 81.45-15.75 112.5-46.35l92.25-92.25-46.35-46.35 57.15-57.15-39.6-39.6-57.15 57.15-57.6-57.6 57.15-57.15-39.6-39.6L384.2 503l-41.85-41.85-92.25 92.25c-55.35 55.35-61.2 141.3-18 203.4l-108.9 108.9v-715.5c0-14.4 11.7-26.1 26.1-26.1h715.5L741.5 247.4c-27-18-58.5-27.9-91.8-27.9-42.75 0-82.35 16.65-112.5 46.8L444.95 358.55l225 225 92.25-92.25c30.15-30.15 46.8-70.2 46.8-112.5 0-32.85-9.9-64.35-28.35-90.9l117-117v702.9c0 13.95-11.25 25.65-25.65 25.65z m-384.3-212.85L435.5 739.25c-40.05 40.05-105.3 40.05-145.8 0-40.05-40.05-40.05-105.3 0-145.8l52.65-52.65 145.35 145.8z m265.05-307.8c0 27.45-10.8 53.55-30.15 72.9l-52.65 52.65-145.8-145.8 52.65-52.65c19.35-19.35 45.45-30.15 72.9-30.15s53.55 10.8 72.9 30.15c19.35 19.35 30.15 45.45 30.15 72.9z" />
			</svg>
		);
	},
});

export default Gateway;
